




























































































import { Component,Vue } from "vue-property-decorator";
import {
	Button,
	Toast
} from "vant";
@Component({
	name: 'NewPersonalOpening',
	components: {
		[Button.name]: Button
	}
})
export default class NewPersonalOpening extends Vue {
	routerType(){
	  (this as any).$apis.getAccountSituation().then(res =>{
		  // hb_account_status  证券  hk_account_status 环球
		  
		  if(res.hb_account_status === 0 && res.hk_account_status === 0){
			  (this as any).$router.push({name:'AccountOpening'})
		  }else if(res.hb_account_status !== 0 && res.hk_account_status === 0){
			  (this as any).$router.push({name:'CognitionOfDerivatives'})
		  }else if(res.hb_account_status === 0 && res.hk_account_status !== 0){
			  (this as any).$router.push({name:'CustomerAgreement1'})
		  }

	  })
	}
}
